import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './contexts/AuthContext';
import PreferencesGuard from './components/PreferencesGuard';
import LandingPage from './pages/LandingPage';
import SwipeInterface from './pages/SwipeInterface';
import SmartFeedTest from './pages/SmartFeedTest';
import Profile from './pages/Profile';
import ProfileOrders from './pages/ProfileOrders';
import ProfileOrderDetail from './pages/ProfileOrderDetail';
import Addresses from './pages/Addresses';
import NotFound from './pages/NotFound';

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

function App() {
  const appTree = (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-background text-foreground">
          <PreferencesGuard>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/discover" element={<SwipeInterface />} />
              <Route path="/smart-feed-test" element={<SmartFeedTest />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/profile/orders" element={<ProfileOrders />} />
              <Route path="/profile/orders/:orderId" element={<ProfileOrderDetail />} />
              <Route path="/addresses" element={<Addresses />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </PreferencesGuard>
        </div>
      </Router>
    </AuthProvider>
  );

  if (googleClientId) {
    return (
      <GoogleOAuthProvider clientId={googleClientId}>
        {appTree}
      </GoogleOAuthProvider>
    );
  }

  return appTree;
}

export default App;
